import { Dimensions } from 'react-native';

import { IS_TABLET, IS_WEB, HAS_NOTCH, IS_PHONE } from '../lib/appConstants';

export function pOrT<A, B>(value: A, nextValue: B): A | B {
  return IS_PHONE ? value : nextValue;
}

export const RED = '#8c0000';
export const GREEN = '#125f32';
export const BLUE = '#1C57FF';
export const LIGHT_BLUE = '#1C57FF';
export const LIGHT_RED = '#E0483E';
export const GREY100 = '#EAEAEA';
export const PURPLE = '#663399';
export const GOLDEN = '#110600';
export const GOLDEN100 = '#8f6b50';
export const GOLDEN200 = '#eccbb4';
export const GOLDEN300 = '#9d3700';

export const WHITE_COLOR = '#fff';
export const FONT_FAMILY = 'Open Sans';
export const FONT_FAMILY_BOLD = !IS_WEB ? 'Open Sans Bold' : 'Open Sans';
export const BASE_COLOR = GOLDEN; //'#eccbb4';
export const SECONDARY_COLOR = '#ffddc6';
export const BACKGROUND_COLOR = 'transparent';

export const TOUCHABLE_7 = 7;
export const TOUCHABLE = IS_TABLET ? 15 : TOUCHABLE_7;
export const TOUCHABLE_4 = 4;
export const TOUCHABLE_MORE = IS_TABLET ? 17 : 10;
export const FORM_WIDTH = 220;

export const PADDING = pOrT(5, 15);
export const PADDING1 = pOrT(5, 10);

export const HP_HEIGHT = pOrT(27, 36);
export const BUTTON_HEIGHT = 37;

export const SAFE_OFFSET = HAS_NOTCH ? 44 : 0;

let wh = Dimensions.get('window').height;
let ww = Dimensions.get('window').width;
let a;
if (wh > ww) {
  a = ww;
  ww = wh;
  wh = a;
}

export const WINDOW_HEIGHT = IS_WEB ? 700 : wh;
// SE 568 8 667 Ipad 1024
export const WINDOW_WIDTH = IS_WEB ? 960 : ww - SAFE_OFFSET * 2;

// 8 375 SE 320 + 414
export const IS_SMALL_HEIGHT = WINDOW_HEIGHT < 330;
// SE 568 + 736
export const IS_SMALL_WIDTH = WINDOW_WIDTH < 600;

export const MARGIN_12 = 12;
export const MARGIN_8 = 8;
export const MARGIN_5 = 5;
export const MARGIN_3 = 3;
export const MARGIN_10 = 10;
export const MARGIN_15 = 15;
export const MARGIN_20 = 20;
export const MARGIN_25 = 25;
export const MARGIN_30 = 30;

export const CONTENT_HEIGHT = WINDOW_HEIGHT - HP_HEIGHT - PADDING * 2;
